
riot.tag2('pay-systems', '  <catalog object="PaySystem" cols="{cols}" reload="true" reorder="true" sortable="true" add="{permission(add, &quot;paysystems&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;paysystems&quot;, &quot;0001&quot;)}" dblclick="{permission(paySystemOpen, &quot;paysystems&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="imageFile"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}"></datatable-cell>\n      <datatable-cell name="name"><i class="fa {row.active == &quot;Y&quot; ? &quot;fa-eye&quot; : &quot;fa-eye-slash text-noactive&quot;}"></i> {row.name}</datatable-cell>\n      <datatable-cell name="discount">{row.discount}</datatable-cell>\n      <datatable-cell name="maxAmount">{row.maxAmount}</datatable-cell>\n      <datatable-cell name="sort">{row.sort}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'PaySystem';

self.cols = [{ name: 'id', value: '#' }, { name: 'imageFile', value: 'Картинка' }, { name: 'name', value: 'Наименование' }, { name: 'discount', value: 'Скидка, %' }, { name: 'maxAmount', value: 'Max сумма' }, { name: 'sort', value: 'Индекс' }];

self.add = function () {
    return riot.route('/settings/pay-systems/new');
};

self.paySystemOpen = function (e) {
    return riot.route('settings/pay-systems/' + e.item.row.id);
};

self.one('updated', function () {
    self.tags.catalog.tags.datatable.on('reorder-end', function () {
        var _self$tags$catalog$pa = self.tags.catalog.pages,
            current = _self$tags$catalog$pa.current,
            limit = _self$tags$catalog$pa.limit;

        var params = { indexes: [] };
        var offset = current > 0 ? (current - 1) * limit : 0;

        self.tags.catalog.items.forEach(function (item, sort) {
            item.sort = sort + offset;
            params.indexes.push({ id: item.id, sort: sort + offset });
        });

        API.request({
            object: 'PaySystem',
            method: 'Sort',
            data: params,
            notFoundRedirect: false
        });
        self.update();
    });
});

observable.on('pay-systems-reload', function () {
    self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/settings/paysystems/pay-systems.tag